const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowEon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 77,
    viewBox: "0 0 93 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M23.9476 74.9756C18.5828 71.0658 12.0308 68.4868 6.72434 64.5694C5.82437 63.9054 2.33464 62.3719 2.02667 61.3126M2.02667 61.3126C1.62775 59.9372 5.5148 58.1816 6.40839 57.75C10.9138 55.5737 18.8109 51.841 24.0017 49.9359M2.02667 61.3126C20.8551 64.3208 49.1288 55.0099 51.1018 40.1057M51.1018 40.1057C51.6241 36.1598 50.303 31.8219 46.4751 27.2168C39.237 18.5098 26.662 27.8602 33.0846 36.0104C36.6313 40.5098 44.6296 40.9148 51.1018 40.1057ZM51.1018 40.1057C52.9607 39.8733 54.6938 39.5408 56.1593 39.1764C74.3286 34.6583 89.1056 17.8946 90.9981 1.99972",
    stroke: "#FFC933",
    strokeWidth: 2.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      stroke: "#ffb6ae",
      strokeOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowEon);
export default __webpack_public_path__ + "static/media/arrowEON.c2258af93b32887410dd36a59b425754.svg";
export { ForwardRef as ReactComponent };